export default "__VITE_ASSET__IuPVwuyG__"